import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { Label } from "reactstrap";
import ReactPaginate from "react-paginate";
import { getGroupKunjunganByCalonNasabah } from "stores";
import { requestIdebitur } from "stores";
import { getAllInformasiDebitur } from "stores";

function DetailCalonNasabahIdeb(data) {
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  moment.locale("id");
  const [listGroup, setListGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [idGroupNasabah, setIdGroupNasabah] = React.useState("");

  const [idUsaha, setIdUsaha] = React.useState("");
  const [dataUsaha, setDataUsaha] = React.useState([]);
  const [listUsaha, setListUsaha] = React.useState([]);
  const [pendingListUsaha, setPendingListUsaha] = React.useState(false);
  const [totalPerHalamanListUsaha, setTotalPerHalamanListUsaha] =
    React.useState(10);
  const [pageListUsaha, setPageListUsaha] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const [searchText, setSearchText] = React.useState("");
  const [statusRequest, setStatusRequest] = useState(data.data.statusRequest);

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };
  const handlePageSizeChangeListUsaha = (selectedOptionListUsaha) => {
    setTotalPerHalamanListUsaha(selectedOptionListUsaha.value);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_NASABAH_IDEB", data: true });
  };

  React.useEffect(() => {
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const reqIdeb = (val) => {
    Swal.fire({
      position: "center",
      icon: "question",
      title: "Info",
      text: "Apakah anda yakin ingin melakukan request informasi debitur?",
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Tidak",
      allowOutsideClick: false,
      cancelButtonColor: "#E22016",
    })
      .then((result) => {
        if (result.isConfirmed) {
          requestIdebitur({
            id_pinjaman: val.loan,
            nama: val.pemilikUsaha.namaPemilikUsaha,
            tglLahir: val.pemilikUsaha.tglLahir,
            nik: val.pemilikUsaha.nik,
            npwp: val.pemilikUsaha.nik,
            jenisKelamin:
              val.pemilikUsaha.kelamin === "L"
                ? "M"
                : val.pemilikUsaha.kelamin === "P"
                ? "F"
                : "-",
            custType: val.pemilikUsaha.custType,
            cabang: val.cabang._id,
            tempatLahir: val.pemilikUsaha.tempatLahir,
            namaIbuKandung: val.pemilikUsaha.namaIbuKandung,
          })
            .then((response) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.message,
              });
              getAllInformasiDebitur(dispatch, {
                cari: searchText,
                page: page + 1,
                limit: totalPerHalaman,
              }).then(() => {
                setStatusRequest(true);
              });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: err.message,
              });
            });
        }
      })
      .catch((err) => {
        console.log(err, "ERRRR");
      });
  };

  return (
    <>
      {/* {korcab.modalDetailUsaha ? (
        korcab.modalKunjunganByGroup ? ( */}
      <Container fluid>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            className="btn-transparent mr-2"
            type="button"
            variant="primary"
            size="md"
            style={{
              border: "none",
              backgroundColor: "#00BFFF",
              marginBottom: 20,
              border: 0,
            }}
            onClick={handleClick}
          >
            <i className="fas fa-arrow-left"></i>
          </Button>

          <Button
            // disabled={data.data.statusRequest ? true : false}
            disabled={statusRequest}
            className="btn-transparent mr-2"
            type="button"
            variant="primary"
            size="md"
            style={{
              border: "none",
              backgroundColor: "#FD7E14",
              marginBottom: 20,
              border: 0,
              cursor: statusRequest ? "not-allowed" : "pointer",
            }}
            onClick={() => reqIdeb(data.data)}
          >
            Request Ideb
          </Button>
        </div>
        <Card>
          <Card.Header>
            <Card.Title
              as="h3"
              style={{
                color: "#2C2B2B",
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              detail nasabah
              <hr></hr>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {/* <Card style={{ border: 0 }}> */}
            <div style={{ maxHeight: "450px", overflowY: "scroll" }}>
              <div className="row">
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    BAP-LOAN
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.loan}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    Id Nasabah
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.idPemilikUsaha}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama lengkap
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.namaPemilikUsaha}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    NIK
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.nik}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    npwp
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.npwp}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tempat lahir
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.tempatLahir}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tanggal lahir
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {moment(data.data.pemilikUsaha.tglLahir).format(
                        "DD MMMM YYYY"
                      )}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    jenis kelamin
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.kelamin}
                    </Label>
                  </li>
                </div>

                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama ibu kandung
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.namaIbuKandung}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    Alamat
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.alamat}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    no handphone
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.noTelp}
                    </Label>
                  </li>
                </div>

                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    kategori Nasabah
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.custType === "1"
                        ? "Perorangan"
                        : data.data.pemilikUsaha.custType === "2"
                        ? "Badan Usaha"
                        : "-"}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    tipe kunjungan
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.pemilikUsaha.tipeKunjungan}
                    </Label>
                  </li>
                </div>

                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    foto ktp
                  </Label>

                  {loading ? (
                    <>
                      <div
                        className="loader-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <ColorRing
                          visible={true}
                          height="80"
                          width="80"
                          ariaLabel="color-ring-loading"
                          wrapperStyle={{}}
                          wrapperClass="color-ring-wrapper"
                          colors={[
                            "#6c757d",
                            "#6c757d",
                            "#6c757d",
                            "#6c757d",
                            "#6c757d",
                          ]}
                        />
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 19,
                          }}
                        ></p>
                      </div>
                    </>
                  ) : (
                    <img
                      src={data.data.tmpFotoKtp}
                      alt="Foto KTP"
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* </Card> */}
          </Card.Body>
        </Card>
      </Container>

      <Container fluid>
        <Card>
          <Card.Header>
            <Card.Title
              as="h3"
              style={{
                color: "#2C2B2B",
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              cabang
              <hr></hr>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {/* <Card style={{ border: 0 }}> */}
            <div style={{ maxHeight: "450px", overflowY: "scroll" }}>
              <div className="row">
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    id cabang
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.cabang.cabang_id}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    nama cabang
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.cabang.namaCabang}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    singkatan
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.cabang.singkatan}
                    </Label>
                  </li>
                </div>
                <div className="col-6">
                  <Label
                    style={{
                      fontSize: 16,
                      marginTop: 15,
                      fontWeight: "bold",
                      color: "#828286",
                      textTransform: "uppercase",
                    }}
                  >
                    alamat
                  </Label>
                  <li>
                    <Label
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        color: "black",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.data.cabang.alamat}
                    </Label>
                  </li>
                </div>
              </div>
            </div>
            {/* </Card> */}
          </Card.Body>
        </Card>
      </Container>
      {/* //   ) : (
      //     <>
      //       <ListKunjunganPerGroup data={idGroupNasabah} />
      //     </>
      //   )
      // ) : (
      //   <DetailCalonNasabahIdeb data={idUsaha} value={dataUsaha} />
      // )} */}
    </>
  );
}

export default DetailCalonNasabahIdeb;
